import { render, staticRenderFns } from "./ModalAdicionarAplicacoes.vue?vue&type=template&id=797ff59e&scoped=true"
import script from "./ModalAdicionarAplicacoes.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarAplicacoes.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarAplicacoes.vue?vue&type=style&index=0&id=797ff59e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ff59e",
  null
  
)

export default component.exports